import { FC } from 'react';

import { useResetPassword } from '@modules/auth/queries/use-reset-password';

import { ResetPasswordInitial } from './ResetPasswordInitial';
import { ResetPasswordSuccess } from './ResetPasswordSuccess';

import type { ResetPasswordMutationResult } from './types';

const ResetPassword: FC = () => {
  const mutation = useResetPassword() as ResetPasswordMutationResult;

  if (mutation.isSuccess) {
    return <ResetPasswordSuccess />;
  }

  return <ResetPasswordInitial mutation={mutation} />;
};

export { ResetPassword };
